<div class="position-relative d-flex p-3 p-md-5 m-md-3 text-center bg-dark intro-banner">
  <div class="col-md-8 p-lg-5 mx-auto text-white align-self-center">
    <h1 class="display-5 font-weight-bold mx-auto">{{'Gestion des déchets' | translate}}</h1>
  </div>
</div>
<contact-us-btn></contact-us-btn>
<hr class="mb-5 mt-3">
<div class="container">
    <div class="text-center my-5 mb-5">
        <span class="title sub-bar">{{'Analyse du secteur de la gestion des déchets' | translate}}</span>
    </div>
    <div class="container justif-center my-5">
      <p><span class="bold-blue">{{ 'Le secteur du management des déchets' | translate}}</span> {{ 'regroupe l’ensemble des procédés qui visent à contrôler les flux de déchets, réduire les dépenses liées à la gestion et au traitement des déchets et à mitiger l’impact des déchets sur l’environnement' | translate}}.</p>
    </div>
</div>
<div class="block-free-access py-5">
    <div class="container px-5">
        <div class="block p-0">
            <ul class="nav landing-tabs" id="myTab" role="tablist">
                <li class="nav-item">
                    <a class="nav-link active" id="global-tab" data-toggle="tab" href="#global" role="tab" aria-controls="global" aria-selected="true" title="World">
                        <div class="icon">
                          <picture>
            									<source srcset="/assets/world_icon.webp" type="image/webp">
                              <source srcset="/assets/world_icon.png" type="image/png">
            									<img src="/assets/world_icon.png" class="pays" alt="Global waste management sector trends: Accidentology and Market Analysis" title="World" loading="lazy"/>
            							</picture>
                        </div>
                        <b class="text-uppercase">{{'Global' | translate}}</b>
                    </a>
                </li>
                <li class="nav-item">
                    <a class="nav-link" id="usa-tab" data-toggle="tab" href="#usa" role="tab" aria-controls="usa" aria-selected="false" title="USA">
                        <div class="icon">
                          <picture>
            									<source srcset="/assets/usa_icon.webp" type="image/webp">
                              <source srcset="/assets/usa_icon.png" type="image/png">
            									<img src="/assets/usa_icon.png" class="pays" alt="United States waste management sector trends: Accidentology and Market Analysis" title="USA" loading="lazy"/>
            							</picture>
                        </div>
                        <b class="text-uppercase">{{'Etats-Unis' | translate}}</b>
                    </a>
                </li>
                <li class="nav-item">
                    <a class="nav-link" id="france-tab" data-toggle="tab" href="#france" role="tab" aria-controls="france" aria-selected="false" title="France">
                        <div class="icon">
                          <picture>
            									<source srcset="/assets/france_icon.webp" type="image/webp">
                              <source srcset="/assets/france_icon.png" type="image/png">
            									<img src="/assets/france_icon.png" class="pays" alt="French waste management sector trends: Accidentology and Market Analysis" title="France" loading="lazy"/>
            							</picture>
                        </div>
                        <b class="text-uppercase">{{'France' | translate}}</b>
                    </a>
                </li>
            </ul>
            <hr class="my-0">
            <div class="tab-content text-center py-4 px-3 px-md-5" id="myTabContent">
                <div class="tab-pane fade show active" id="global" role="tabpanel" aria-labelledby="global-tab">
                    <b class="sub-bar">{{'GLOBAL' | translate}}</b>
                    <p class="mb-0 mt-4 sub-title"><i class="fas fa-check-circle mr-2 custom-circle"></i>{{'ACCIDENTS :' | translate}}</p>
                    <ul class="mb-0 mt-2 text-justify">
                      <li>{{'Incendies causés par le stockage de combustibles et déchets inflammables.' | translate}} <a class="source" href="https://www.aria.developpement-durable.gouv.fr/wp-content/uploads/2017/06/2016-10-11-SY-AccidentologieDechetsVersionSimplifiee-PA-EN-Vfin.pdf" target="_blank" rel="noopener nofollow" title="aria">{{'(source)' | translate}}</a></li>
                      <li>{{'Le secteur du déchet est actuellement classé comme 3ème secteur le plus enclin aux accidents.' | translate}} <a class="source" href="https://www.aria.developpement-durable.gouv.fr/wp-content/uploads/2017/06/2016-10-11-SY-AccidentologieDechetsVersionSimplifiee-PA-EN-Vfin.pdf" target="_blank" rel="noopener nofollow" title="aria">{{'(source)' | translate}}</a></li>
                    </ul>
                    <p class="mb-0 mt-4 sub-title"><i class="fas fa-check-circle mr-2 custom-circle"></i>{{'MARCHÉ :' | translate}}</p>
                    <ul class="mb-0 mt-2 text-justify">
                      <li>{{'Le marché mondial de la gestion des déchets a été évalué à 394,1 milliard de dollars américains en 2020 et est estimé à 715 milliards de dollars à l’horizon 2030.' | translate}} <a class="source" href="https://www.prnewswire.com/news-releases/global-waste-management-market-2021-to-2030---by-waste-type-service-and-region-301413066.html#:~:text=The%20Global%20Waste%20Management%20Market,6.1%25%20from%202021%2D2030." target="_blank" rel="noopener nofollow" title="prnewswire">{{'(source)' | translate}}</a></li>
                    </ul>
                </div>
                <div class="tab-pane fade" id="usa" role="tabpanel" aria-labelledby="usa-tab">
                  <b class="sub-bar">{{'ETATS-UNIS' | translate}}</b>
                  <p class="mb-0 mt-4 sub-title"><i class="fas fa-check-circle mr-2 custom-circle"></i>{{'ACCIDENTS :' | translate}}</p>
                  <ul class="mb-0 mt-2 text-justify">
                    <li>{{'107 accidents mortels avec les camion bennes en 2017 en Amérique du Nord.' | translate}} <a class="source" href="https://www.truckingwatchdog.com/2019/07/17/garbage-trucks/" target="_blank" rel="noopener nofollow" title="truckingwatchdog">{{'(source)' | translate}}</a></li>
                    <li>{{'Plus de 1400 blessés dans des accidents de camions bennes.' | translate}} <a class="source" href="https://www.truckingwatchdog.com/2019/07/17/garbage-trucks/" target="_blank" rel="noopener nofollow" title="truckingwatchdog">{{'(source)' | translate}}</a></li>
                  </ul>
                  <p class="mb-0 mt-4 sub-title"><i class="fas fa-check-circle mr-2 custom-circle"></i>{{'MARCHÉ :' | translate}}</p>
                  <ul class="mb-0 mt-2 text-justify">
                    <li>{{'Les collecteurs de déchets et de matériaux recyclables occupaient la sixième place des professions les plus meurtrières aux États-Unis en 2019.' | translate}} <a class="source" href="https://www.recyclingtoday.com/article/bls-waste-recycling-collection-fatality/" target="_blank" rel="noopener nofollow" title="recyclingtoday">{{'(source)' | translate}}</a></li>
                  </ul>
                </div>
                <div class="tab-pane fade" id="france" role="tabpanel" aria-labelledby="france-tab">
                  <b class="sub-bar">{{'FRANCE' | translate}}</b>
                  <p class="mb-0 mt-4 sub-title"><i class="fas fa-check-circle mr-2 custom-circle"></i>{{'ACCIDENTS :' | translate}}</p>
                  <ul class="mb-0 mt-2 text-justify">
                    <li>{{'L’accidentologie du secteur d’activité des déchets et des eaux usées a augmenté de manière notable entre 2010 et 2019 passant de 14,5% des événements recensés à 24,2%.' | translate}} <a class="source" href="https://www.aria.developpement-durable.gouv.fr/wp-content/uploads/2021/05/synthese-dechets-VF.pdf" target="_blank" rel="noopener nofollow" title="aria">{{'(source)' | translate}}</a></li>
                  </ul>
                  <p class="mb-0 mt-4 sub-title"><i class="fas fa-check-circle mr-2 custom-circle"></i>{{'MARCHÉ :' | translate}}</p>
                  <ul class="mb-0 mt-2 text-justify">
                    <li>{{'Près de 600 entreprises en France exercent sous le code APE NAF38 réservé à la Collecte, le traitement et l’élimination des déchets; récupération de matériaux.' | translate}} <a class="source" href="https://www.aria.developpement-durable.gouv.fr/wp-content/uploads/2017/06/2016-10-11-SY-AccidentologieDechetsVersionSimplifiee-PA-EN-Vfin.pdf" target="_blank" rel="noopener nofollow" title="aria">{{'(source)' | translate}}</a></li>
                    <li>{{'Trackdéchet devient obligatoire à compter du 1er janvier 2022 pour tous les acteurs du déchet dangereux.' | translate}} <a class="source" href="https://trackdechets.beta.gouv.fr/" target="_blank" rel="noopener nofollow" title="trackdechets">{{'(source)' | translate}}</a></li>
                  </ul>
                </div>
            </div>
        </div>
    </div>
</div>
<div class="container my-5">
    <div class="text-center mb-5">
        <span class="title sub-bar">{{'Challenges du secteur' | translate}}</span>
    </div>
    <div class="row pt-4">
        <div class="col-12 col-md-6 px-4 pt-4 mb-md-4 mb-4 d-flex justify-content-center align-items-center">
            <div>
                <p class="challenge"><app-svg-icon [src]="'assets/svg/1-icone.svg'" [size]="'28px'" class="fas mr-2 custom-circle number-icon"></app-svg-icon>{{'Redynamiser la formation HSE :' | translate}}</p>
                <p class="text-justify">{{'Ce secteur doit faire face à un taux important de turnover. Ce secteur souffre donc d’un manque de formation et de sensibilisation autour des enjeux de santé, de sécurité et d’environnement.' | translate}}</p>
                <div class="vertical-line">
                  <p class="font-weight-bold ifsolution">{{'Comment Immersive Factory peut vous aider :' | translate}}</p>
                  {{'Notre catalogue riche de plus de 30 exercices en VR dédiés aux formations HSE peut vous aider dans vos formations ou dans l’organisation de' | translate}} <a class="source" [routerLink]="language.navigateAccordingToLang(['/journee-securite'])" target="_blank" rel="noopener nofollow" title="Safety Days">{{'Journées Sécurité' | translate}}</a>{{'. Avec nos animateurs, assurez-vous que vos équipes soient sensibilisées aux risques et qu’elles soient capables de réagir en cas de situation d’accident.' | translate}}
                </div>
            </div>
        </div>
        <div class="col-12 col-md-6 mb-md-0 px-4 mb-md-4 mb-4">
          <div class="videoContainer block-rounded abstract-formation mb-2">
              <video title="EHS VR workshops catalog" poster="https://immersivemisc.s3.eu-west-3.amazonaws.com/videos/posters/Multi_Screens_Journee_Securite.jpg" autoplay="autoplay" muted="muted" webkit-playsinline="true" playsinline="true" loop="loop" preload="auto">
                  <source src="https://immersivemisc.s3.eu-west-3.amazonaws.com/videos/Multi_Screens_Journee_Securite.webm" type="video/webm">
                  <source src="https://immersivemisc.s3.eu-west-3.amazonaws.com/videos/Multi_Screens_Journee_Securite.mp4" type="video/mp4">
              </video>
          </div>
        </div>
    </div>
    <hr class="px-2 mb-4">
    <div class="row pt-4">
        <div class="col-12 col-md-6 mb-md-0 px-4 mb-md-4 mb-4">
            <picture>
                <source srcset="assets/femme_VR_V2.webp" type="image/webp">
                <source srcset="assets/femme_VR_V2.jpg" type="image/jpg">
                <img src="assets/femme_VR_V2.jpg" class="block-rounded" alt="VR training workshop waste management" title="VR training" loading="lazy">
            </picture>
        </div>
        <!-- <div class="col-12 col-md-6 mb-md-0 px-4 mb-md-4 mb-4">
          <div class="block-rounded embed-responsive embed-responsive-16by9 shadow">
              <iframe class="embed-responsive-item" src="https://www.youtube.com/embed/okW-SL2Qqfw?version=3&loop=1&playlist=okW-SL2Qqfw&showinfo=0&controls=0&autoplay=1&mute=1"></iframe>
          </div>
        </div> -->
        <div class="col-12 col-md-6 px-4 pt-4 mb-md-4 mb-4 d-flex justify-content-center align-items-center">
            <div>
                <p class="challenge"><app-svg-icon [src]="'assets/svg/2-icone.svg'" [size]="'28px'" class="fas mr-2 custom-circle number-icon"></app-svg-icon>{{'Identifier correctement les risques pour prévenir les accidents :' | translate}}</p>
                <p class="text-justify">{{'Les formations actuelles se basent sur des procédures et lignes de conduite datées et caduques. Cela est souvent en raison d’une mauvaise identification des risques ce qui mène régulièrement à des comportements humains inappropriés.' | translate}}</p>
                <div class="vertical-line">
                  <p class="font-weight-bold ifsolution">{{'Comment Immersive Factory peut vous aider :' | translate}}</p>
                  {{'La plupart de nos exercices sont co-développés avec de grands acteurs du secteur. C’est une façon de nous assurer que les formations que nous construisons sont pertinentes et parfaitement adaptées aux risques quotidiens auxquels votre équipe est confrontée.' | translate}}
                </div>
            </div>
        </div>
    </div>
    <hr class="px-2 my-4">
    <div class="row pt-4">
        <div class="col-12 col-md-6 px-4 pt-4 mb-md-4 mb-4 d-flex justify-content-center align-items-center">
            <div>
                <p class="challenge"><app-svg-icon [src]="'assets/svg/3-icone.svg'" [size]="'28px'" class="fas mr-2 custom-circle number-icon"></app-svg-icon>{{'Faire face à la pluralité et à la fréquence des risques :' | translate}}</p>
                <p class="text-justify">{{'Les accidents qui surviennent dans le secteur de la gestion des déchets sont aussi variés que fréquents.' | translate}}</p>
                <div class="vertical-line">
                  <p class="font-weight-bold ifsolution">{{'Comment Immersive Factory peut vous aider :' | translate}}</p>
                  {{'Profitez de notre catalogue multi-secteurs pour sensibiliser vos équipes à de multiples types d\’accidents : conduite, produits chimiques, feux, explosions, manipulation, gestes, postures, collisions, environnement et encore beaucoup d’autres. Et avec notre abonnement, c’est le même prix, peu importe combien d\'exercices vous souhaitez utiliser !' | translate}}
                </div>
            </div>
        </div>
        <div class="col-12 col-md-6 mb-md-0 px-4 mb-md-4 mb-4">
          <div class="videoContainer block-rounded abstract-formation mb-2">
              <video poster="https://immersivemisc.s3.eu-west-3.amazonaws.com/videos/posters/Accident.jpg" autoplay="autoplay" muted="muted" webkit-playsinline="true" playsinline="true" loop="loop" preload="auto">
                  <source src="https://immersivemisc.s3.eu-west-3.amazonaws.com/videos/Accidents.webm" type="video/webm">
                  <source src="https://immersivemisc.s3.eu-west-3.amazonaws.com/videos/Accidents.mp4" type="video/mp4">
              </video>
          </div>
        </div>
    </div>
    <hr class="px-2 mb-4">
    <div class="row pt-4">
        <div class="col-12 col-md-6 mb-md-0 px-4 mb-md-4 mb-4">
            <picture>
                <source srcset="assets/new_training_room.webp" type="image/webp">
                <source srcset="assets/new_training_room.jpg" type="image/jpg">
                <img src="assets/new_training_room.jpg" class="block-rounded" alt="Virtual campus training room" title="Training room" loading="lazy">
            </picture>
        </div>
        <div class="col-12 col-md-6 px-4 pt-4 mb-md-4 mb-4 d-flex justify-content-center align-items-center">
            <div>
                <p class="challenge"><app-svg-icon [src]="'assets/svg/4-icone.svg'" [size]="'28px'" class="fas mr-2 custom-circle number-icon"></app-svg-icon>{{'Construire et animer une communauté HSE :' | translate}}</p>
                <p class="text-justify">{{'Votre équipe fait face à de nombreux risques : manipulations manuelles, positions de travail, vibrations, contact avec des produits chimiques et des agents biologiques, bruit, risques mécaniques… Ces dangers ne sont pas débattus et le secteur n’est pas considéré comme un secteur à haut risque.' | translate}}</p>
                <div class="vertical-line">
                  <p class="font-weight-bold ifsolution">{{'Comment Immersive Factory peut vous aider :' | translate}}</p>
                  <a class="source" [routerLink]="language.navigateAccordingToLang(['/journee-securite'])" target="_blank" rel="noopener nofollow" title="Safety Days">{{'Organisez des Journées Sécurité' | translate}}</a> {{'où toute l’entreprise sera sensibilisée à l’ensemble des risques. De cette façon, tout le monde pourra comprendre les contraintes du métier; même les personnes qui ne sont pas exposées.' | translate}}
                </div>
            </div>
        </div>
    </div>
</div>
<hr class="mt-4 mb-0 pb-0">
<div class="grey py-5">
  <div class="container text-justify">
      <div class="text-center mb-5">
          <span class="title sub-bar">{{'Pourquoi former votre personnel à la gestion des déchets ?' | translate}}</span>
      </div>
      <p>{{"Les déchets représentent une part significative des émissions de gaz à effet de serre dans le monde. Pour les entreprises, il est donc important de trouver des solutions pour réduire cette pollution et protéger l’environnement" | translate}}.</p>
      <p>{{"La gestion des déchets est un processus complexe qui nécessite la formation de vos employés. Pour former vos employés à la gestion des déchets, vous devez commencer par les bases : qu’est-ce qu’un déchet ? Quels sont les différents types de déchets ? Quels sont leurs dangers ?" | translate }}</p>
      <p>{{"Une fois que vos employés ont ces connaissances, vous pouvez passer à une formation plus spécifique, par exemple sur la manière de collecter et de transporter correctement les déchets" | translate }}.</p>
      <p>{{"Vous pouvez également dispenser une formation sur les différentes méthodes de traitement et d’élimination des déchets" | translate }}.</p>
      <p>{{"Enfin, il est important de rappeler à vos employés l’importance de respecter les procédures de gestion des déchets mises en place pour protéger l’environnement !" | translate }}</p>
  </div>
</div>
<hr class="mb-4 mt-0 pt-0">
<div class="container my-5">
    <div class="text-center mb-5">
        <span class="title sub-bar">{{'Voulez-vous garantir la sécurité et la conformité de vos employés lorsqu\’ils gèrent les déchets ?' | translate}}</span>
    </div>
    <div class="row d-flex align-items-center">
      <div class="col-12 col-md-6 px-4 mb-md-0 mb-4">
          <picture>
              <source srcset="assets/Formation-homme-vr2.webp" type="image/webp">
              <source srcset="assets/Formation-homme-vr2.jpg" type="image/jpg">
              <img src="assets/Formation-homme-vr2.jpg" class="block-rounded" alt="A man using a VR headset to train for EHS hazards" title="VR EHS workshops" loading="lazy">
          </picture>
      </div>
      <div class="col-12 col-md-6 px-4 text-justify">
        <p>{{"Nos formations en VR sur la gestion des déchets offrent une expérience réaliste et immersive qui préparera vos employés à toute situation. Ils apprendront à manipuler les déchets en toute sécurité et conformément à la réglementation, en se protégeant eux-mêmes et en protégeant l’environnement" | translate}}.</p>
        <p>{{"Avec notre formation VR sur la gestion des déchets, vous pouvez être sûr que vos employés aient les compétences nécessaires pour travailler en toute sécurité et efficacement avec la gestion des déchets. La formation est réaliste, engageante et informative - parfaite pour garantir que votre lieu de travail est conforme et sûr" | translate }}.</p>
        <p class="pb-0 mb-0">{{"La gestion des déchets est un processus complexe, mais il est essentiel pour les entreprises de réduire leur impact sur l’environnement. En formant vos employés aux procédures appropriées de gestion des déchets, vous pouvez faire une différence significative !" | translate }}</p>
      </div>
    </div>
</div>
<hr *ngIf="blocnews" class="mb-4 pt-0 mt-0">
<div *ngIf="blocnews" class="container">
    <div class="text-center my-5 mb-5">
        <span class="title sub-bar">{{'Vous voulez en savoir plus sur les bénéfices de l\’apprentissage immersif dans le secteur du management des déchets ?' | translate}}</span>
    </div>
    <div class="container my-5">
      <p class="justif-center">{{ 'Découvrez ses nombreux avantages au travers de cet article de blog :' | translate}}</p>
      <div *ngIf="blocnews" class="mt-4">
        <div class="post row pr-0">
            <div class="col-12 col-md-6 mb-md-0 px-0">
                <a *ngIf="blocnews['link']" [routerLink]="language.navigateAccordingToLang([blocnews['link']])" target="blank" rel="noopener nofollow" title="{{blocnews['title']}}"><img src='{{blocnews.imageHeader}}' class="news-image abstract-formation" alt="Immersive learning in the US" title="Testimonial" loading="lazy"></a>
            </div>
            <div class="col-12 col-md-6 px-4 pt-4 mb-4 d-flex justify-content-center align-items-center">
                <div>
                    <p *ngIf="blocnews['title']" class="font-weight-bold ifsolution">{{blocnews["title"]}}</p>
                    <div class="informations my-3">
                        <span *ngIf="blocnews['createdDate']" class="date">{{blocnews["createdDate"]}}</span>
                        <div *ngIf="blocnews.tag['title']" class="tag rounded px-2">{{blocnews.tag["title"]}}</div>
                    </div>
                    <div class="actu-body">
                      <p *ngIf="blocnews['shortDesc']" class="description" [innerHTML]="blocnews['shortDesc']"></p>
                      <a *ngIf="blocnews['link']" [routerLink]="language.navigateAccordingToLang([blocnews['link']])" class="viewmore mb-3" target="blank" rel="noopener nofollow" title="{{blocnews['title']}}">{{'Voir plus' | translate}}</a>
                    </div>
                </div>
            </div>
        </div>
      </div>
    </div>
</div>


<hr class="mt-5">
<div class="reassurance">
    <div class="container py-4 mb-4">
        <h3 class="my-4">{{ 'Ils nous font confiance' | translate}}</h3>
        <owl-carousel
            [options]="{
                items: 5,
                dots: false,
                nav: true,
                margin:0,
                loop:true,
                autoplay:true,
                autoplayTimeout:3000,
                autoplayHoverPause:true,
                responsive:{
                    '300':{
                        items:1,
                        nav:true
                    },
                    '768':{
                        items:3,
                        nav:true
                    },
                    '992':{
                        items:5,
                        nav:true,
                        loop:true
                    }
                }
            }"
            [carouselClasses]="['owl-carousel']">
            <div class="logos-theytrustus" *ngFor="let image of images;let i = index">
                <picture>
                    <source srcset="{{image.url}}.webp" type="image/webp">
                    <source srcset="{{image.url}}.png" type="image/png">
                    <img src="{{image.url}}.png" [attr.alt]="image.alt" [attr.title]="image.title" loading="lazy">
                </picture>
            </div>
        </owl-carousel>
    </div>
</div>
<hr class="my-4">


<div class="container mb-5">
    <div class="text-center my-5 mb-5">
        <span class="title sub-bar">{{'exercices dédiés au secteur de la gestion des déchets' | translate}}</span>
    </div>
    <div *ngIf="listProducts" class="mt-4">
        <div class="row ml-0 mr-0">
          <app-product-card class="col-md-4 mt-4"  *ngFor="let product of listProducts" [product]="product"></app-product-card>
        </div>
    </div>
</div>
<hr class="my-4">
<div class="container">
    <!-- <div class="text-center my-5 mb-5">
        <span class="title sub-bar">{{'Vous voulez en savoir plus sur les bénéfices de l’apprentissage immersif dans le secteur du management des déchets ?' | translate}}</span>
    </div> -->

    <div class="container-fluid mt-5 mb-5">
        <div class="row">
            <div class="col-md-6 col-12 latest-pub">
                <h2 class="title-pub bold px-4 pt-2">{{'Téléchargez notre dernier témoignage client' | translate}}</h2>
                <h3 class="text-pub mt-2 px-4">{{'Témoignage SUEZ' | translate}}</h3>
                <a href="https://communication.immersivefactory.com/{{'temoignage-suez-fr.pdf' | translate}}" target="_blank" rel="noopener nofollow" title="SUEZ testimonial">
                <div class="download-btn mt-4">
                    <i class="fas fa-download"></i><span class="ml-2">{{'Télécharger' | translate}}</span>
                </div>
                </a>
            </div>
            <div class="col-md-6 col-12 book">
                <div class="magasine magasine-{{language.lang}}">
                </div>
            </div>
        </div>
    </div>
</div>
